import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var removeItemByIndex = function removeItemByIndex(array, index) {
  return [].concat(_toConsumableArray(array.slice(0, index)), _toConsumableArray(array.slice(index + 1)));
};

var addItemToIndex = function addItemToIndex(array, index, item) {
  return [].concat(_toConsumableArray(array.slice(0, index)), [item], _toConsumableArray(array.slice(index)));
};

var addItem = function addItem(array, item) {
  return [].concat(_toConsumableArray(array), [item]);
};

var replaceItemOnIndex = function replaceItemOnIndex(array, index, item) {
  return [].concat(_toConsumableArray(array.slice(0, index)), [item], _toConsumableArray(array.slice(index + 1)));
};

var removeItemByKey = function removeItemByKey(object, key) {
  // eslint-disable-next-line no-unused-vars
  var value = object[key],
      withoutKey = _objectWithoutProperties(object, [key].map(_toPropertyKey));

  return withoutKey;
};

export default {
  addItem: addItem,
  addItemToIndex: addItemToIndex,
  removeItemByIndex: removeItemByIndex,
  removeItemByKey: removeItemByKey,
  replaceItemOnIndex: replaceItemOnIndex
};